import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";
import LeaderboardParticipantDetails from "./ParticipantDetails";
import ParticipantAvatar from "./ParticipantAvatar";
import ParticipantRank from "./ParticipantRank";
import ParticipantStats from "./ParticipantStats";
import MVMIcon from "../../Common/MVMIcon";
const ParticipantListItem = (props) => {
    const { participant, distanceUnit, isDetailsOpened, showJersey = true, isTeamList = false, } = props;
    const [showDetails, setShowDetails] = useState(isDetailsOpened);
    const renderName = () => {
        if (participant.type === "user") {
            return (React.createElement("p", { className: "weight-600 mb-0" },
                participant.firstName,
                " ",
                React.createElement("span", { className: "weight-300" }, participant.lastName)));
        }
        return React.createElement("p", { className: "weight-600 mb-0" }, participant.teamName);
    };
    const renderContent = () => {
        if (showDetails) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(ParticipantAvatar, { type: participant.type, id: participant.id, firstName: participant.firstName, image: participant.image, countryCode: participant.countryCode }),
            React.createElement("div", { className: "d-flex flex-column flex-fill" },
                renderName(),
                React.createElement(ParticipantStats, { isTeamList: isTeamList, distance: participant.distance, distanceUnit: distanceUnit, completionPct: participant.completionPct })),
            React.createElement("div", { className: "leaderboard-rank" },
                React.createElement(ParticipantRank, { showJersey: showJersey && participant.isFirst, rank: participant.rank }),
                participant.type === "team" && (React.createElement(MVMIcon, { icon: "right-arrow", className: "rotate-90", height: 16, width: 16 })))));
    };
    return (React.createElement("div", { className: "leaderboard-participant p-2" },
        React.createElement(CSSTransition, { in: isDetailsOpened, timeout: 300, classNames: "leaderboard-participant-animation", unmountOnExit: true, onEnter: () => setShowDetails(true), onExited: () => setShowDetails(false) },
            React.createElement(LeaderboardParticipantDetails, { ...props })),
        renderContent()));
};
export default ParticipantListItem;
